import { Inject, Injectable } from '@angular/core';
import { FirebasePermissionService } from './firebase-permission.service';
import { NFirebase } from './firebase.interface';
import { FIREBASE_OPTIONS } from './firebase.options';

@Injectable({
    providedIn: 'root'
})
export class FirebaseService {
    constructor(
        protected firebasePermissionService: FirebasePermissionService,
        @Inject(FIREBASE_OPTIONS) protected options: NFirebase.IOptions
    ) {}

    init(): void {
        this.firebasePermissionService.init();
    }
}
